export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Linguagem"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bom dia"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boa tarde"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boa noite"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boa noite"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sair"])}
}